<template>
  <div>
    <el-row style="background-color:white;">
      <el-col>
        <el-form :inline="true" class="demo-form-inline" style="margin-top: 20px;" :model="searchForm" ref="searchForm"
          @keyup.enter.native="queryList">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="queryList()">筛选</el-button>
            <el-button size="medium" @click="addKind()">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="background-color:white;margin-top:10px;">
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="120"></el-table-column>
          <el-table-column prop="TAX_RATE" label="税率"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="changeThis(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--新增的模态框-->
    <el-dialog title="新增" :visible.sync="addVisible" width="600px" center>
      <el-form ref="addForm" :model="addForm" :rules="rule" @keyup.enter.native="addSure">
        <el-form-item label="产品名称：">
          <el-select filterable v-model="addForm.PRODUCT_CODE" clearable placeholder="请选择" style="width:450px;">
            <el-option v-for="item in listKinds" :key="item.PRODUCT_CODE" :label="item.NAME" :value="item.PRODUCT_CODE">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="税率:" label-width="80px" prop="TAX_RATE">
          <el-input v-model="addForm.TAX_RATE" style="width:450px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button @click="addSure()">确定</el-button>
      </span>
    </el-dialog>
    <!--修改的模态框-->
    <el-dialog title="修改" :visible.sync="changeVisible" width="600px" center>
      <el-form :ref="modifyForm" :model="modifyForm" :rules="rule" @keyup.enter.native="modifySure">
        <el-form-item label="税率:" label-width="100px" prop="TAX_RATE">
          <el-input v-model="modifyForm.TAX_RATE" style="width:450px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeVisible = false">取消</el-button>
        <el-button @click="modifySure()">确定</el-button>
      </span>
    </el-dialog>
    <div class="pagination_box" v-show="total_count > pageSize">
      <el-pagination style="float:right;" @current-change="handleCurrentChange" :current-page.sync="currentPage"
        :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="total_count">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { queryUseSKU } from '@/assets/api/skuManage';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      rule: {
        TAX_RATE: [{ required: true, message: '请输入税率', trigger: 'blur' }],
      },
      formLabelWidth: '80px',
      changeVisible: false,
      tableData: [],
      searchForm: {
        PRODUCT_CODE: '',
      },
      currentPage: 1,
      pageSize: 15,
      modifyForm: {},
      total_count: 0,
      addVisible: false,
      addForm: {},
      listKinds: [],
      reg: /^[0-9]+(.[0-9]{1})?$/,
    };
  },
  computed: { },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.firstList();
  },
  methods: {
    queryList() {
      this.currentPage = 1;
      this.firstList();
    },
    // 查询所有未添加的二类
    queryKinds() {
      const params = {
        STATUS: 1,
        PAGESIZE: 9999,
        PAGEINDEX: 0,
        CATALOG_ID: Number(this.$route.params.cid),
      };
      queryUseSKU(params).then((result) => {
        if (result[0]) {
          this.listKinds = result[0].list;
        } else {
          this.listKinds = [];
        }
        this.addVisible = true;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增
    addKind() {
      this.queryKinds();
    },
    addSure() {
      if (!this.addForm.PRODUCT_CODE) {
        this.$message.show({ text: '请选择产品', type: 'warning' });
        return false;
      }
      if (!this.reg.test(this.addForm.TAX_RATE) || this.addForm.TAX_RATE >= 100) {
        this.$message.show({ text: '请输入小于100且至多一位小数的正数税率', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '15066',
        OTYPE: 4,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: Number(this.$route.params.sid),
        CATALOG_ID: Number(this.$route.params.cid),
        PRODUCT_CODE: this.addForm.PRODUCT_CODE,
        TAX_RATE: this.addForm.TAX_RATE,
      };
      http.post(params).then((result) => {
        if (result[0]) {
          this.$message.show({ text: '当前商品已设置过税率', type: 'warning' });
        } else {
          this.addForm = {};
          this.$message.show({ text: '新增成功', type: 'success' });
          this.currentPage = 1;
          this.firstList();
          this.addVisible = false;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拉取列表
    firstList() {
      const params = {
        SERVICE_ID: '15066',
        OTYPE: 5,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: Number(this.$route.params.sid),
        CATALOG_ID: Number(this.$route.params.cid),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http.post(params).then((result) => {
        if (result[0].TOTAL_COUNT == 0) {
          this.total_count = 0;
          this.tableData = [];
        } else {
          this.total_count = result[0].TOTAL_COUNT;
          this.tableData = result[0].LIST;
        }
        if (this.searchForm) {
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.firstList();
    },
    // 修改
    changeThis(row) {
      this.modifyForm = { ...row };
      this.changeVisible = true;
    },
    // 修改确认
    modifySure() {
      if (!this.reg.test(this.modifyForm.TAX_RATE) || this.modifyForm.TAX_RATE >= 100) {
        this.$message.show({ text: '请输入小于100且至多一位小数的正数税率', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '15066',
        OTYPE: 6,
        TAX_RATE: this.modifyForm.TAX_RATE,
        TABLE_ID: this.modifyForm.TABLE_ID,
      };
      http.post(params).then((result) => {
        this.modifyForm = {};
        this.firstList();
        this.$message.show({ text: '修改成功', type: 'success' });
        this.changeVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SKUManage/productManage_supplier.vue